<div class="canvas-container">
  <canvas [id]="id" #barchartcanvas [class.hidden]="isNoData()"></canvas>

  @if(!isNoData()) {
  <button (click)="exportChart()">
    <ng-icon name="screenshot" size="22"></ng-icon>
  </button>
  } @if(isNoData()) {
  <div class="no-data">
    <ng-icon name="reports" size="64"></ng-icon>
    <p>{{ dictionaryService.get('NoDataFound') }}</p>
  </div>
  }
</div>
